import React from 'react';
import NotAvailable from '../Common/NotAvailable';

interface ProviderExperienceSectionProps {
  yearsExperience: number | null;
}

const ProviderExperienceSection: React.FC<ProviderExperienceSectionProps> = ({
  yearsExperience,
}) => {
  return (
    <section className="mb-8">
      <h3 className="font-['Ovo'] text-xl text-[#1f1f1f] uppercase mb-4">YEARS OF EXPERIENCE</h3>
      <p className="font-['Open_Sans'] text-base text-[#1f1f1f]">
        {/* NULL means unknown (imported providers) */}
        {yearsExperience && yearsExperience > 0 ? (
          `${yearsExperience} ${yearsExperience === 1 ? 'year' : 'years'}`
        ) : (
          <NotAvailable />
        )}
      </p>
    </section>
  );
};

export default ProviderExperienceSection;
